import { useUpgrade } from '~/hooks/useUpgrade'
import { useStorageSpace } from '~/hooks/useStorageSpace'
import { useAddFeature } from '~/features/paymentDesk'
import type {
  ORDER_BEHAVIOR,
  ORDER_TYPE,
  RIGHTS_FEATURE,
} from '~/api/interface'
import { PageKey } from '~/constants/page'
import type { ProductUpdateMsg } from '~/api/interface/message.ts'
import { getProductUpdateMsg } from '~/api'
import { showUpdateLog } from '~/hooks/useModal/modals/lastUpdate'

export function useEntryMounted() {
  const route = useRoute()
  const userInfo = useUserInfo()

  const { data: tabInfo } = useAsyncData(async () => {
    if (userInfo.value && !loginTask.tasks.length) {
      return await getProductUpdateMsg()
    }
    return Promise.resolve({
      code: 0,
      data: {} as ProductUpdateMsg,
    })
  })

  watch(
    () => tabInfo?.value?.data?.tab_card_list,
    () => {
      tabInfo?.value?.data?.tab_card_list &&
        showUpdateLog(
          tabInfo?.value?.data?.tab_card_list,
          tabInfo?.value?.data?.document_url
        )
    }
  )
  onMounted(() => {
    if (route.query.upgrade) {
      if (isGlobalVersion()) {
        return navigateTo({ name: PageKey.SUBSCRIBE })
      }
      useUpgrade()
      return
    }

    if (route.query.storageSpace) {
      useStorageSpace({ type: Number(route.query.type) })
      return
    }

    if (route.query.addFeature) {
      useAddFeature({
        title: route.query.title as string,
        user_info: userInfo.value,
        feature_type: route.query.feature_type as RIGHTS_FEATURE,
        behavior: Number(route.query.behavior) as ORDER_BEHAVIOR,
        order_type: Number(route.query.order_type) as ORDER_TYPE,
      })
    }
  })
}
